export default __webpack_public_path__ + "static/media/jalapenos.6cab22a4.png";